import React, { Component } from 'react';
import { hideModal, MODAL_QUESTION_MULTY_CATEGORY_FRAME } from '../../../../../../modules/modals';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import {toastr} from 'react-redux-toastr'
import SwitchField from '../../../../../helpers/Fields/SwitchField';
import { updateQuestionCategory } from '../../../../actions';

class FrameModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state = {
      question: props.question
    }
  }

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_QUESTION_MULTY_CATEGORY_FRAME});

  }
  componentDidMount(){
    this.setState({question: this.props.question})
  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleFrameQuestionCategory"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }
  componentWillReceiveProps(nextProps){
    this.setState({question: nextProps.question})
  }

  copy = () => {
    var copyText = document.getElementById("question_frame");
    const {formatMessage} = this.context
    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand("copy");
    toastr.success(formatMessage('titleFrameCopy'), formatMessage('msgFrameCopy'))
  }

  render() {
    const {formatMessage} = this.context
    const { zIndex, id} = this.props;
    const {question} = this.state;
    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <div className="create-dialog-form">
              <div className="row mb-5">
                <textarea rows={4} id="question_frame" style={{width: '100%', border: '1px solid #d9d9d9'}}>
                  {`<iframe src="https://${window.location.hostname}/question_multy/view/${question.token}" width="100%" height="570" frameborder="0"></iframe>`}
                </textarea>
              </div>
              <div className="flex" style={{alignItems: 'center', justifyContent:'center'}}>
                <button className="btn btn-primary" onClick={this.copy} >{formatMessage('btnModalCopy')}</button>
              </div>
            </div>
          </div>
      </Modal>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
})

const mapDispatchToProps = {
  hideModal,
  updateQuestionCategory
}

export default connect(mapStateToProps, mapDispatchToProps)(FrameModal)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Category/components/FrameModal/index.jsx